import InvoiceSection from "@/components/InvoiceSection";
// Invoices section wrapper for the WO form. Resolves jobsite
// address + the billing contact (name / email / phone) from the
// active site's overrides, the client-level billing contact, or
// the site's primary contact — in that order. Extracted from
// WorkOrderTab.jsx (Feb 2026, iter179).
export function WOInvoicesPanel({
  editingWO,
  form,
  clientName,
  clientId,
  clientCustomerNumber,
  clientSites,
  clientBillingContact,
  getSiteNameById,
}) {
  if (!editingWO) return null;

  const site = clientSites.find(x => x.id === form.site_id);
  const jobsiteAddress = site
    ? [site.address, site.city, site.state, site.zip_code].filter(Boolean).join(", ")
    : "";

  // 3-tier resolver: site-level billing override → client-level
  // billing contact → site primary contact (or first contact).
  const resolveContactField = (siteField, clientField, contactField) => {
    if (site?.use_site_billing && site?.[siteField]) return site[siteField];
    if (clientBillingContact?.[clientField]) return clientBillingContact[clientField];
    const c = (site?.contacts || []).find(x => x.is_primary) || (site?.contacts || [])[0];
    return c?.[contactField] || "";
  };

  return (
    <InvoiceSection
      woId={editingWO.id}
      woNumber={editingWO.wo_number || form.wo_number}
      woTitle={form.title || ""}
      clientName={clientName}
      clientId={clientId}
      customerNumber={clientCustomerNumber || ""}
      siteId={form.site_id}
      siteName={getSiteNameById(form.site_id) || ""}
      projectManagerId={form.project_manager_id}
      projectManagerName={form.project_manager_name}
      lineItems={form.line_items}
      changeOrders={form.change_orders}
      taxRate={form.tax_rate}
      woTaxOverride={form.tax_override || null}
      hideTax={!!form.hide_tax}
      jobsiteAddress={jobsiteAddress}
      contactName={resolveContactField("billing_contact_name", "name", "name")}
      contactEmail={resolveContactField("billing_contact_email", "email", "email")}
      contactPhone={resolveContactField("billing_contact_phone", "phone", "phone")}
    />
  );
}
